enum CountryCode {
  Canada = 'CA',
  Germany = 'DE',
  UnitedKingdom = 'GB',
  UnitedStates = 'US',
}

export { CountryCode };
